import me from './administrator/me';
import collection from './administrator/collection';
import item from './administrator/item';

const administrator = {
  namespaced: true,
  modules: {
    me,
    collection,
    item,
  },
};

export default administrator;
